<template>
  <div id="seller">
    <div class="list">
      <div class="tabbar">
        <div :class="item===selectItem?'isAcitve':''" v-for="(item,index) in tabbarItem" :key="index" @click="clickItem(item,index)">
          {{item}}
        </div>
      </div>
      <div class="filter">
        <div class="select_ground">
          <div class="select_data">
            <el-select v-model="value" clearable :popper-append-to-body="false" placeholder="选择时间" @change="selectTimeChange">
              <el-option
                v-for="(item,index) in options"
                :key="index.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="select_game">
            <el-select v-model="selectGameValue" clearable :popper-append-to-body="false" placeholder="选择游戏" @change="selectGameChange" >
              <el-option
                v-for="(item,index) in selectGame"
                :key="index"
                :label="item.label"
                :value="{value:item.value,label:item.label}">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="filter_search">
          <input type="text" v-model="match" class="filter_search_input" placeholder="请输入账户关键词">
          <span class="filter_search_btn" @click="clickMatch">确认</span>
        </div>
      </div>
      <div class="product_list">
        <el-table
          :data="tableData"
          @row-click="tablaRowClick"
          style="width: 100%">
          <!-- 空数据 -->
          <template slot="empty">
            <div class="no_data">
              <empty-state
                title="暂无出售装备"
                description="可以调整筛选条件后再次查看"
                icon="el-icon-box"
                :icon-size="52">
              </empty-state>
            </div>
          </template>
        <!-- 商品信息 -->
        <el-table-column
          label="商品信息"
          width="480">
          <template slot-scope="scope">
            <div class="product">
              <div class="product__img">
                <img v-if="scope.row.status===1" src="@/assets/image/PersonalCenter/Seller/sellerstatus4.png" />
                <img v-else-if="scope.row.status===4" src="@/assets/image/PersonalCenter/Seller/sellerstatus5.png" />
                <el-popover v-else
                  placement="right"
                  trigger="hover"
                  :close-delay="100">
                  <img :src="scope.row.image" alt="" width="260px" height="260px">
                  <img :src="scope.row.image" alt="" slot="reference">
                </el-popover>

              </div>
              <div class="product_info">
                <div class="product_info_top">
                  <span>{{ scope.row.game_name }}</span>
                  {{scope.row.name}}
                  {{scope.row.content}}
                </div>
                <div class="product_info_mid">
                  <span class="gaming_zone" v-for="(categoryItem,index) in scope.row.category" :key="index">
                    {{categoryItem.name}}：
                    <span>
                      {{categoryItem.value}}
                    </span>
                  </span>
                </div>
                <div class="product_info_bot">
                  <span id="release_date">发布时间：{{ scope.row.add_time|moment }}</span>
                  <span id="browse">
<!--                    <img src="@/assets/image/Home/topGamesIco.png" alt="">-->
                    热度:
                    <span>
                      {{ scope.row.click }}
                    </span>
                  </span>
                  <span id="collect">收藏：{{ scope.row.collect }}</span>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <!-- 金额 -->
        <el-table-column label="金额">
          <template slot-scope="scope">
            <div class="product_price">¥{{scope.row.sell_price}}</div>
          </template>
        </el-table-column>
        <!-- 库存 -->
        <el-table-column label="库存">
          <template slot-scope="scope">
            <div class="num">{{scope.row.num}}</div>
          </template>
        </el-table-column>
        <!-- 状态 -->
        <el-table-column
          label="状态"
          width="111">
          <template slot-scope="scope">
            <div slot="reference" class="name-wrapper">
              <el-tag v-if="scope.row.status===1" size="medium">审核中</el-tag>
              <el-tag v-else-if="scope.row.status===2" type="warning" size="medium">在售</el-tag>
              <el-tag v-else-if="scope.row.status===3" type="info" size="medium">下架</el-tag>
              <el-tag v-else-if="scope.row.status===4" type="danger" size="medium">审核失败</el-tag>
            </div>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column
          label="操作"
          width="100">
          <template slot-scope="scope">
            <!-- 待审核 -->
            <div v-if="scope.row.status===1 || scope.row.status===4" class="btn_ground">
              <a v-if="scope.row.sys_service_type == 2||scope.row.sys_service_type == 3" class="modify" @click.stop="cusSerBtnClicks(scope.row)">联系客服</a>
              <a v-else target="_blank" class="modify" @click.stop="$accessLink(scope.row.game_customer)" :href="`${scope.row.game_customer}?u_cust_id=${$store.state.userData.user_id}&u_cust_name=${$store.state.userData.nickname}`">联系客服</a>
            </div>
            <!-- 在售 -->
            <div v-if="scope.row.status===2" class="btn_ground">
              <div class="thumbs_up" @click.stop="productGore(scope.row)">顶一顶</div>
              <el-popover
                placement="left"
                width="160"
                popper-class="btn_ground_popover"
                trigger="hover">
                <div class="popoverBtnList">
                  <div @click.stop="handleEditPrice(scope.$index, scope.row)">改价</div>
                  <div @click.stop="productOff(scope.row)">下架</div>
                  <div @click.stop="AddInventory(scope.row)">添加库存</div>
                </div>
                <div slot="reference" class="modify" @click.stop>编辑</div>
              </el-popover>
            </div>
            <!-- 下架 -->
            <div v-else-if="scope.row.status===3" class="btn_ground">
              <a target="_blank" class="ask_service" @click.stop="AddInventory(scope.row)" :href="scope.row.game_customer">添加库存</a>
            </div>
          </template>
        </el-table-column>
        </el-table>
        <div class="pages" v-if="totalCount !== 0">
          <common-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="PageSize"
            layout="prev, pager, next, jumper"
            :total="totalCount">
          </common-pagination>
        </div>
      </div>
    </div>
    <el-dialog custom-class="AddInventory"
               title="修改商品库存"
               :visible.sync="dialogFormVisible"
               width="500px"
               top="27vh"
               center>
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="库存数量:" class="dialogInput" :label-width="formLabelWidth" prop="num">
          <el-input v-model="form.num" autocomplete="off" placeholder="请输入库存数量"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm('form')">确认修改</el-button>
      </div>
    </el-dialog>
    <el-dialog title="求降价设置"
               custom-class="premiumSet"
               :visible.sync="premiumSet"
               width="500px"
               top="27vh"
               center>
      <el-form :model="premiumSetForm" ref="premiumSetForm">
        <el-form-item label="是否接受议价:" class="premiumSet" label-width="140px" prop="is_premium">
          <el-radio-group v-model="premiumSetForm.is_premium">
            <el-radio label="1">接受议价</el-radio>
            <el-radio label="0">不接受议价</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitPForm('premiumSetForm')">确认修改</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  apiGameList,
  apiSellerEquipList,
  apirEquipGore,
  apirEquipOffshelf,
  apiSellerEquipEditPrice,
  apirEquipInventory,
  apiPremiumEdit
} from "@/request/API";
import CommonPagination from "@/components/commonPagination";
import EmptyState from "@/components/emptyState";

export default {
  name: '',
  props: {
  },
  components: {
    CommonPagination,
    EmptyState
  },
  data () {
    return {
      // 默认显示第几页
      currentPage:1,
      // 总条数，根据接口获取数据长度(注意：这里不能为空)
      totalCount:0,
      // 默认每页显示的条数（可修改）
      PageSize:10,
      selectItem:'全部',
      selectItemIndex:0,
      //tabbar
      tabbarItem:[
        '全部','待审核','在售','下架 ','审核失败',
      ],
      //账号列表
      tableData: [],
      //选择时间下拉框
      options: [
        {value: '0', label: '全部'},
        {value: '1', label: '本周内'},
        {value: '2', label: '当月'},
        {value: '3', label: '三个月内'},
        {value: '4', label: '半年内'},
        {value: '5', label: '半年以上'},
        {value: '6', label: '一年内'},
      ],
      value: '',
      //选择游戏下拉框
      selectGame: [],
      selectGameValue: '',
      //关键字搜索
      match:'',
      //修改账号密码
      account:'',
      pwd:'',
      dialogFormVisible: false,
      premiumSet:false,
      form: {
        id:'',
        num:''
      },
      rules: {
        num:[
          { required: true, message: '请输入库存数量', trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: '请输入大于0的库存数量' }
        ],
      },
      premiumSetForm:{
        is_premium:'',
        id:'',
        game_id:'',
      },
      formLabelWidth: '120px'
    }
  },
  methods: {
    cusSerBtnClicks(item) {
      this.$openIM({
        ysdscode: 'htmg',
        gameAlias: 'htmg',
      })
    },
    tablaRowClick(row, column, event){
      if (this.selectItemIndex !== 6) {
        if (row.status === 2) {
          this.$router.push({
            name:'EquipmentDetails',
            query:{
              game_id:row.game_id,
              id:row.id
            }
          });
        }else{
          this.$message({
            type:'error',
            center:true,
            message:'该账号不存在或未上架'
          })
        }
      }else{
        this.$router.push({
          name:'GameDetails',
          query:{
            game_id:row.game_id,
            id:row.product_id,
            source_page: this.$route.path.slice(1)
          }
        });
      }

    },
    //tabbar
    clickItem(item, index) {
      this.currentPage = 1
      //获取游戏列表
      apiGameList({
      }).then(res=>{
        res.data.forEach((item,index)=>{
          let options = new Object()
          options.value = item.game_id
          options.label = item.game_name
          this.selectGame.push(options)
        })
      })
      this.selectItem = item
      this.selectItemIndex = index
      this.getDataList(this.value,this.selectGameValue.value,this.selectItemIndex,this.match,this.currentPage)
    },
    //table监听事件
    handleEditPrice(index, row) {
      const h = this.$createElement;
      this.$msgbox({
        title:'',
        message: h('div', {class:'confirm_content'}, [
          h('div', {class:'confirm_original_price'}, '当前价格：'+row.sell_price+''),
          h('div',{class:'confirm_modify_bid'}, [
            h('div', {class:'confirm_modify_bid_text'}, '修改出价：'),
            h('input', {class:'confirm_modify_bid_input',attrs:{placeholder: "输入修改后的价格",id:"confirm_modify_bid_input"}}),
          ]),
        ]),
        confirmButtonText: '确认修改',
        confirmButtonClass:'change_price_btn',
        customClass: 'change_price_seller',
        closeOnClickModal:false,
        showClose:true,
        callback: action => {
          if(action === "confirm"){
            apiSellerEquipEditPrice({
              id:row.id,
              game_id:row.game_id,
              sell_price:document.getElementById("confirm_modify_bid_input").value
            }).then(res=>{
              this.$message({
                message:'修改成功',
                center:true,
                type:'success'
              })
              this.currentPage = 1
              this.getDataList(this.value,this.selectGameValue.value,this.selectItemIndex,this.match,this.currentPage)
            }).catch(err=>{
              this.$message({
                message:err.msg,
                center:true,
                type:'error'
              })
            })
          }
          document.getElementById("confirm_modify_bid_input").value = ''
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          apirEquipInventory({
            id:this.form.id,
            num:this.form.num
          }).then(res=>{
            this.$message({
              type:"success",
              center:true,
              message:"修改成功"
            })
            this.dialogFormVisible = false
            this.currentPage = 1
            this.getDataList(this.value,this.selectGameValue.value,this.selectItemIndex,this.match,this.currentPage)
          }).catch(err=>{
            this.$message({
              type:"error",
              center:true,
              message:err.msg
            })
          })
        }
      })
    },
    submitPForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          apiPremiumEdit({
            id:this.premiumSetForm.id,
            game_id:this.premiumSetForm.game_id,
            status:this.premiumSetForm.is_premium,
          }).then(res=>{
            this.$message({
              type:"success",
              center:true,
              message:"修改成功"
            })
            this.premiumSet = false
            this.currentPage = 1
            this.getDataList(this.value,this.selectGameValue.value,this.selectItemIndex,this.match,this.currentPage)
          }).catch(err=>{
            this.$message({
              type:"error",
              center:true,
              message:err.msg
            })
          })
        }
      })
    },

    //分页监听事件
    handleCurrentChange(val) {
      this.currentPage = val
      this.getDataList(this.value,this.selectGameValue.value,this.selectItemIndex,this.match,this.currentPage)
      document.body.scrollTop = document.documentElement.scrollTop = 220;
    },
    //顶一顶
    productGore(data){
      apirEquipGore({
        id:data.id,
      }).then(res=>{
        this.$message({
          type:"success",
          center:true,
          message:"顶一顶操作成功"
        })
      }).catch(err=>{
        this.$message({
          type:"error",
          center:true,
          message:err.msg
        })
      })
    },
    //下架
    productOff(data){
      this.$alert('是否确认下架？如需再次上架需联系客服', '注意', {
        confirmButtonText: '确认',
        confirmButtonClass:'agree_confirm_btn',
        customClass: 'agree_confirm',
        callback: action => {
          if(action === "confirm"){
            apirEquipOffshelf({
              id:data.id,
            }).then(res=>{
              this.$message({
                type:"success",
                center:true,
                message:'下架成功'
              })
              this.currentPage = 1
              this.getDataList(this.value,this.selectGameValue.value,this.selectItemIndex,this.match,this.currentPage)
            }).catch(err=>{
              this.$message({
                type:"error",
                center:true,
                message:err.msg
              })
            })
          }
        }
      });
    },
    /**
     * 添加库存
     * @param data 行数据
     */
    AddInventory(data){
      this.dialogFormVisible = true
      this.form.id = data.id
      this.form.num = data.num
    },
    //议价设置
    premiumSetClick(data){
      this.premiumSet = true
      this.premiumSetForm.is_premium = data.is_premium+''
      this.premiumSetForm.id = data.id
      this.premiumSetForm.game_id = data.game_id
    },
    //游戏筛选 下拉框监听事件
    selectGameChange(event){
      this.currentPage = 1
      this.getDataList(this.value,this.selectGameValue.value,this.selectItemIndex,this.match,this.currentPage)
    },
    //时间筛选 下拉框监听事件
    selectTimeChange(value){
      this.value = value
      this.currentPage = 1
      this.getDataList(this.value,this.selectGameValue.value,this.selectItemIndex,this.match,this.currentPage)
    },
    //关键字搜索
    clickMatch(){
      this.currentPage = 1
      this.getDataList(this.value,this.selectGameValue.value,this.selectItemIndex,this.match,this.currentPage)
    },
    /**
     * 获取 数据 列表
     * @param type    选择时间 下拉框
     * @param game_id 选择游戏 下拉框
     * @param status  tabbar 0～5
     * @param match   关键字
     */
    getDataList(type,game_id,status,match,page){
      apiSellerEquipList({
        type:type,
        game_id:game_id,
        status:status,
        match:match,
        page:page
      }).then(res=>{
        this.totalCount = res.data.total
        this.tableData = res.data.list
      })
    },
    //初始化数据
    onLoad(){
      //获取游戏列表
      apiGameList({
      }).then(res=>{
        res.data.forEach((item,index)=>{
          let options = new Object()
          options.value = item.game_id
          options.label = item.game_name
          this.selectGame.push(options)
        })
      })
      //获取 账号列表
      apiSellerEquipList({
      }).then(res=>{
        this.totalCount = res.data.total
        this.tableData = res.data.list
      })
    }
  },
  mounted () {
    //初始化数据
    if(typeof(this.$route.params.selectItem) !== 'undefined'){
      this.clickItem(this.$route.params.selectItem,this.$route.params.selectItemIndex)
    }else{
      this.onLoad()
    }
  },
  watch: {

  },
  computed: {

  }
}
</script>
<!-- 弹框 -->
<style lang="less">
.agree_confirm{
  width: 386px !important;
  height: 232px !important;
  background: #FFFFFF !important;
  border-radius: 4px !important;
  padding: 0;
  border: none;
  .el-message-box__header,.el-message-box__content,.el-message-box__btns{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
  }
  .el-message-box__title{
    margin-top: 38px;
    font-size: 20px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: #5B5B5B;
    line-height: 28px;
  }
  .el-message-box__container{
    margin-top: 30px;
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #5B5B5B;
    line-height: 22px;
  }
  .agree_confirm_btn{
    margin-top: 36px;
    padding: 0;
    width: 200px;
    height: 40px;
    line-height: 40px;
    background: var(--primary, #FF5A1F) !important;
    border-radius: 3px;
    border: none;
    font-size: 18px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: #FFFFFF !important;
  }
  .agree_confirm_btn:hover{
    background: var(--primary-hover, #E84A12) !important;
  }
}
.change_price_seller{
  width: 500px !important;
  height: 250px !important;
  background: #FFFFFF !important;
  border-radius: 4px !important;
  padding: 0;
  border: none;
  .el-message-box__header>.el-message-box__title{
    display: none;
  }
  .el-message-box__header,.el-message-box__content{
    display: flex;
    flex-direction: column;
    padding: 0 0 0 70px;
  }
  .el-message-box__btns{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
  }
  .el-message-box__title{
    margin-top: 38px;
    font-size: 20px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: #5B5B5B;
    line-height: 28px;
  }
  .el-message-box__container{
    margin-top: 34px;
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #5B5B5B;
    line-height: 22px;
  }
  .change_price_btn{
    margin-top: 40px;
    padding: 0;
    width: 200px;
    height: 40px;
    line-height: 40px;
    background: var(--primary, #FF5A1F) !important;
    border-radius: 3px;
    border: none;
    font-size: 18px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: #FFFFFF !important;
  }
  .change_price_btn:hover{
    background: var(--primary-hover, #E84A12) !important;
  }
  .confirm_content{
    display: flex;
    flex-direction: column;
  }
  .confirm_original_price{
    font-size: 20px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: #FC4A00;
    line-height: 28px;
    margin-bottom: 20px;
  }
  .confirm_modify_bid{
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .confirm_modify_bid_text{
    font-size: 20px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #5B5B5B;
    line-height: 28px;
  }
  .confirm_modify_bid_input{
    width: 210px;
    height: 40px;
    background: #F9F9F9;
    border-radius: 4px;
    border: 1px solid #F0F0F0;
    padding: 0 20px;
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    line-height: 22px;
  }
  .confirm_modify_bid_input::-webkit-input-placeholder {
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #D1D1D1;
  }
}
.sellPopconfirm{
  .el-popconfirm{
    .el-popconfirm__action{
      .el-button{
        span{
          color: #FCAD13;
          font-family: PingFangSC-Light, PingFang SC;
        }
      }
      .el-button--productOff{
        border: none;
        background: #FCAD13;
        span{
          color: #FFFFFF;
        }
      }
    }
  }
}
.refuse_confirm{
  width: 500px !important;
  height: 300px !important;
  background: #FFFFFF !important;
  border-radius: 4px !important;
  padding: 0;
  border: none;
  .el-message-box__header>.el-message-box__title{
    display: none;
  }
  .el-message-box__header,.el-message-box__content{
    display: flex;
    flex-direction: column;
    padding: 0 0 0 70px;
  }
  .el-message-box__btns{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
  }
  .el-message-box__title{
    margin-top: 38px;
    font-size: 20px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: #5B5B5B;
    line-height: 28px;
  }
  .el-message-box__container{
    margin-top: 34px;
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #5B5B5B;
    line-height: 22px;
  }
  .refuse_confirm_btn{
    margin-top: 20px;
    padding: 0;
    width: 200px;
    height: 40px;
    line-height: 40px;
    background: var(--primary, #FF5A1F) !important;
    border-radius: 3px;
    border: none;
    font-size: 18px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: #FFFFFF !important;
    justify-content: center;
  }
  .refuse_confirm_btn:hover{
    background: var(--primary-hover, #E84A12) !important;
  }
  .confirm_content{
    display: flex;
    flex-direction: column;
  }
  .confirm_original_price{
    font-size: 20px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: #FC4A00;
    line-height: 28px;
    margin-bottom: 20px;
  }
  .confirm_my_bid{
    font-size: 20px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #5B5B5B;
    line-height: 28px;
    margin-bottom: 20px;
  }
  .confirm_modify_bid{
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .confirm_modify_bid_text{
    font-size: 20px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #5B5B5B;
    line-height: 28px;
  }
  .confirm_modify_bid_input{
    width: 210px;
    height: 40px;
    background: #F9F9F9;
    border-radius: 4px;
    border: 1px solid #F0F0F0;
    padding: 0 20px;
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    line-height: 22px;
  }
  .confirm_modify_bid_tips{
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #BFBFBF;
    line-height: 22px;
    margin-left: 35px;
  }
  .confirm_modify_bid_input::-webkit-input-placeholder {
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #D1D1D1;
  }
}
.btn_ground_popover{
  .popoverBtnList{
    div{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      font-size: 14px;
      font-family: PingFangSC-Thin, PingFang SC;
      font-weight: 100;
      color: #8F8F8F;
      line-height: 20px;
      padding: 2px 0;
      border-bottom: 1px solid #F5F5F5;
    }
    div:last-of-type{
      border: none;
    }
    div:hover{
      color: #FCAD13;
    }
  }
}
</style>
<style lang="less" scoped>
#seller{
  padding: 0;
  color: var(--text-main, #111827);

  *,
  *:before,
  *:after{
    box-sizing: border-box;
  }

  .list{
    min-height: 620px;
    padding: 20px;
  }

  .tabbar{
    min-height: 40px;
    height: auto;
    margin-top: 0;
    padding: 4px 0 8px;
    display: flex;
    align-items: center;
    gap: 8px;
    background: transparent;
    border: none;
    border-radius: 0;
    overflow: visible;

    div{
      min-width: 76px;
      height: 34px;
      margin-right: 0;
      padding: 0 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: var(--text-secondary, #5A5F6B);
      line-height: 20px;
      cursor: pointer;
      transition: color .2s ease, background .2s ease, box-shadow .2s ease;
    }

    div:hover{
      color: var(--text-main, #1A1D24);
      background: var(--bg-tag, #F0EDE8);
    }

    .isAcitve,
    .isAcitve:hover{
      padding-bottom: 0;
      color: #FFFFFF;
      font-size: 14px;
      font-weight: 500;
      background: var(--bg-dark, #1A1D24);
      box-shadow: 0 8px 18px rgba(26, 29, 36, 0.18);
    }
  }

  .filter{
    min-height: 40px;
    height: auto;
    margin: 18px 0;
    padding: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    background: transparent;
    border: none;
    border-radius: 0;

    .select_ground{
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 12px;

      .select_data{
        margin-right: 0;
      }

      /deep/.el-input__inner{
        width: 180px;
        height: 40px;
        padding: 0 34px 0 14px;
        background: var(--bg-card, #FFFFFF);
        border-radius: 4px;
        border: 1px solid var(--border-soft, #E8E4DE);
        color: var(--text-main, #111827);
        font-size: 14px;
        transition: border-color .2s ease, box-shadow .2s ease;
      }

      /deep/.el-input.is-focus .el-input__inner,
      /deep/.el-input__inner:focus{
        border-color: var(--primary, #FF5A1F);
        box-shadow: none;
      }

      /deep/.popper__arrow{
        left: 155px !important;
      }

      /deep/.el-select-dropdown{
        border-color: var(--border-soft, #E8E4DE);
        border-radius: 4px;
        box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
      }

      /deep/.el-select-dropdown__item{
        color: var(--text-secondary, #5A5F6B);
      }

      /deep/.el-select-dropdown__item.hover,
      /deep/.el-select-dropdown__item:hover{
        background: var(--bg-tag, #F0EDE8);
      }

      /deep/.el-select-dropdown__item.selected{
        color: var(--primary, #FF5A1F);
        font-weight: 500;
      }
    }

    .filter_search{
      width: 318px;
      height: 40px;
      display: flex;
      flex-direction: row;
      align-items: center;
      flex-shrink: 0;
      position: static;
      overflow: hidden;
      background: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      transition: border-color .2s ease, box-shadow .2s ease;

      &:focus-within{
        border-color: var(--primary, #FF5A1F);
        box-shadow: none;
      }

      .filter_search_input{
        width: 100%;
        min-width: 0;
        height: 38px;
        padding: 0 16px;
        background: transparent;
        border: none;
        outline: none;
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        color: var(--text-main, #111827);
      }

      .filter_search_input::-webkit-input-placeholder{
        font-size: 14px;
        color: var(--text-muted, #9AA0AC);
      }

      .filter_search_btn{
        position: static;
        width: 92px;
        height: 32px;
        margin-right: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        background: var(--primary, #FF5A1F);
        border-radius: 3px;
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 20px;
        cursor: pointer;
        box-shadow: none;
        transition: box-shadow .2s ease, opacity .2s ease, background .2s ease;
      }

      .filter_search_btn:hover{
        opacity: 1;
        background: var(--primary-hover, #E84A12);
        box-shadow: none;
      }
    }
  }

  .product_list{
    overflow: hidden;
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    background: var(--bg-card, #FFFFFF);

    /deep/.el-table{
      color: var(--text-main, #111827);
    }

    /deep/.el-table:before{
      display: none;
    }

    /deep/.el-table th{
      height: 48px;
      background: var(--bg-tag, #F7F5F2);
      border-bottom: 1px solid var(--border-soft, #E8E4DE);
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 500;
      color: var(--text-secondary, #5A5F6B);
    }

    /deep/.el-table th>.cell,
    /deep/.el-table .cell{
      padding: 0;
      text-align: center;
    }

    /deep/.el-table td{
      padding: 0;
      border-bottom: 1px solid var(--border-soft, #E8E4DE);
    }

    /deep/.el-table__row:hover td{
      background: var(--bg-tag, #F7F5F2);
    }

    /deep/.el-tag{
      height: 28px;
      padding: 0 10px;
      display: inline-flex;
      align-items: center;
      border: none;
      border-radius: 4px;
      background: var(--primary-soft, #FCEDE5);
      color: var(--gold, #C9974D);
      font-size: 13px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 500;
    }

    /deep/.el-tag.el-tag--danger{
      background: var(--primary-soft, #FCEDE5);
      color: var(--hot, #FF2D55);
    }

    /deep/.el-tag.el-tag--info{
      background: var(--bg-tag, #F0EDE8);
      color: var(--text-muted, #9AA0AC);
    }

    /deep/.el-tag.el-tag--warning{
      background: var(--primary-soft, #FCEDE5);
      color: var(--primary, #FF5A1F);
    }

    .product{
      height: 168px;
      padding: 18px 0 18px 18px;
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    .product__img{
      width: 124px;
      height: 124px;
      margin-right: 18px;
      flex: 0 0 124px;
      overflow: hidden;
      background: var(--bg-tag, #F0EDE8);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;

      img,
      /deep/.el-image{
        height: 100%;
        width: 100%;
        display: block;
        object-fit: cover;
        border-radius: 0;
      }
    }

    .product_info{
      width: 320px;
      height: 124px;
      min-width: 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    .product_info_top{
      min-height: 48px;
      max-height: 48px;
      height: 48px;
      margin-bottom: 0;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-align: left;
      font-size: 15px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 500;
      color: var(--text-main, #111827);
      line-height: 24px;
      -webkit-line-clamp: 2;

      span{
        height: 22px;
        margin: 1px 8px 0 0;
        padding: 2px 8px;
        display: inline-flex;
        align-items: center;
        vertical-align: top;
        font-size: 12px;
        color: var(--text-main, #1A1D24);
        line-height: 18px;
        background: var(--bg-tag, #F0EDE8);
        border-radius: 4px;
      }
    }

    .product_info_mid{
      min-height: 44px;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      gap: 6px 8px;
      text-align: left;
      overflow: hidden;

      .gaming_zone{
        width: auto;
        max-width: 128px;
        height: 22px;
        padding: 0 8px;
        display: inline-flex;
        align-items: center;
        background: var(--bg-tag, #F7F5F2);
        border: 1px solid var(--border-soft, #E8E4DE);
        border-radius: 4px;
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        color: var(--text-secondary, #5A5F6B);
        line-height: 20px;

        span{
          min-width: 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 12px;
          color: var(--text-main, #111827);
        }
      }
    }

    .product_info_bot{
      min-height: 22px;
      font-size: 12px;
      font-family: PingFang SC-Regular, PingFang SC;
      color: var(--text-muted, #9AA0AC);
      line-height: 22px;
      display: flex;
      align-items: center;
      flex-direction: row;
      gap: 18px;
      white-space: nowrap;

      #release_date,
      #browse{
        margin-right: 0;
      }
    }

    .product_price{
      font-size: 20px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 600;
      color: var(--primary, #FF7A1A);
      line-height: 28px;
    }

    .num{
      font-size: 15px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 500;
      color: var(--text-main, #111827);
      line-height: 22px;
    }

    .btn_ground{
      padding: 0 10px;
      display: flex;
      flex-direction: column;
      align-items: stretch;
      gap: 8px;

      div,
      a{
        height: 30px;
        min-width: 72px;
        padding: 0 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        font-size: 13px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 500;
        line-height: 18px;
        text-decoration: none;
        cursor: pointer;
        transition: color .2s ease, background .2s ease, border-color .2s ease, box-shadow .2s ease, opacity .2s ease;
      }

      .thumbs_up,
      .ask_service{
        background: var(--bg-dark, #1A1D24);
        border: none;
        color: #FFFFFF;
        box-shadow: 0 6px 14px rgba(26, 29, 36, 0.16);
      }

      .thumbs_up:hover,
      .ask_service:hover{
        opacity: .92;
        box-shadow: 0 8px 18px rgba(26, 29, 36, 0.22);
      }

      .modify{
        margin: 0;
        background: var(--bg-card, #FFFFFF);
        border: 1.5px solid var(--bg-dark, #1A1D24);
        color: var(--text-main, #1A1D24);
      }

      .modify:hover{
        background: var(--bg-tag, #F0EDE8);
      }
    }

    .pages{
      min-height: 88px;
      height: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      background: var(--bg-card, #FFFFFF);
    }

    .no_data{
      min-height: 300px;
      padding: 64px 36px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  /deep/.AddInventory,
  /deep/.premiumSet{
    position: relative;
    overflow: hidden;
    border-radius: 4px;
    box-shadow: none;
    filter: drop-shadow(0 18px 46px rgba(26, 29, 36, 0.14));

    .el-dialog__header{
      height: 54px;
      padding: 0;
      background: var(--bg-dark, #1A1D24);
      border-radius: 4px 4px 0 0;
      border-bottom: none;
      text-align: center;
    }

    .el-dialog__title{
      font-size: 18px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      color: #FFFFFF;
      line-height: 54px;
      letter-spacing: 1px;
    }

    .el-dialog__headerbtn{
      top: 17px;
      right: 20px;
      width: 20px;
      height: 20px;
    }

    .el-dialog__close{
      color: rgba(255, 255, 255, 0.86);
      font-size: 18px;
      transition: color 0.2s ease, transform 0.2s ease;
    }

    .el-dialog__headerbtn:hover .el-dialog__close{
      color: #FFFFFF;
      transform: rotate(90deg);
    }

    .el-dialog__body{
      padding: 30px 58px 2px;
      background: var(--bg-card, #FFFFFF);
    }

    .el-dialog__footer{
      padding: 18px 20px 36px;
      background: var(--bg-card, #FFFFFF);
      border-radius: 0 0 4px 4px;
    }

    .el-form-item{
      margin-bottom: 16px;
    }

    .el-form-item__label{
      font-size: 15px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 500;
      color: var(--text-secondary, #5A5F6B);
      line-height: 40px;
    }

    .el-input__inner{
      width: 250px;
      height: 40px;
      background: var(--bg-tag, #F7F5F2);
      border-radius: 4px;
      border: 1px solid var(--border-soft, #E8E4DE);
      color: var(--text-main, #111827);
      font-size: 14px;
      transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
    }

    .el-input__inner:hover{
      border-color: var(--border-strong, #D8D2CA);
    }

    .el-input__inner:focus{
      border-color: var(--primary, #FF5A1F);
      background: #FFFFFF;
      box-shadow: none;
    }

    .el-input__inner::-webkit-input-placeholder{
      font-size: 14px;
      color: var(--text-muted, #9AA0AC);
    }

    .el-button{
      width: 200px;
      height: 40px;
      padding: 0;
      background: var(--primary, #FF5A1F);
      border-radius: 3px;
      border: none;
      font-size: 15px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 40px;
      transition: box-shadow 0.2s ease, opacity 0.2s ease, background 0.2s ease;
    }

    .el-button:hover{
      background: var(--primary-hover, #E84A12);
      box-shadow: none;
      opacity: 1;
    }
  }

  /deep/.premiumSet{
    .el-dialog__body{
      padding: 34px 58px 8px;
    }

    .el-form-item{
      margin-bottom: 10px;
    }

    .el-form-item__content{
      line-height: 40px;
    }
  }

  /deep/.is-checked .el-radio__inner {
    border-color: var(--primary, #FF5A1F);
    background: var(--primary, #FF5A1F);
  }

  /deep/.el-radio.is-checked>.el-radio__label{
    color: var(--primary, #FF5A1F);
  }
}
</style>
<style lang="less">
.btn_ground_popover{
  min-width: 132px;
  padding: 8px !important;
  border-color: var(--border-soft, #E8E4DE);
  border-radius: 4px;
  box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));

  .popoverBtnList{
    display: flex;
    flex-direction: column;

    div{
      min-height: 34px;
      padding: 0 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 20px;
      color: var(--text-secondary, #5A5F6B);
      border-bottom: 1px solid var(--border-soft, #E8E4DE);
      cursor: pointer;
      transition: color .2s ease, background .2s ease;
    }

    div:last-of-type{
      border-bottom: none;
    }

    div:hover{
      color: var(--primary, #FF5A1F);
      background: var(--bg-tag, #F0EDE8);
    }
  }
}
</style>
